<template>
  <div class="text" v-html="content" ref="text"></div>
</template>

<script>
export default {
  name: 'WYSIWYG',
  props: ['content'],

  mounted () {
    const forms = this.$refs.text.querySelectorAll('.wpcf7-form')
    this.initContactForms(forms)
  },

  methods: {
    initContactForms (forms) {
      if (forms.length > 0) {
        forms.forEach(form => {
          form.addEventListener('submit', e => {
            e.preventDefault()
            this.$store.dispatch('submitForm', form)
          })
        })
      }
    }
  }
}
</script>
